import { render } from "./Certificados.vue?vue&type=template&id=285d054f"
import script from "./Certificados.vue?vue&type=script&lang=js"
export * from "./Certificados.vue?vue&type=script&lang=js"

import "./Certificados.vue?vue&type=style&index=0&id=285d054f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__